module.exports = __webpack_public_path__ + "static/media/Real-time Sync-pana.d5b78396.svg";